import style from './AccountBalances.module.css';
import { colors } from '../../../../colorVars';
import { fields } from './fieldList';
import { Body3 } from '../../../atomic/text/Text';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../utils/math/ApplyRounding';
import { EditableTableField } from '../../../atomic/inputs/editableTableField/EditableTableField';
import { modifyNickname } from '../../../../stores/websocketStore/utils/outgoingMessages/acctbalance/modifyNickname';
import TextButton from '../../../atomic/buttons/textButton/TextButton';
import { resetSimAccount } from '../../../../stores/websocketStore/utils/outgoingMessages/acctbalance/resetSimAccount';

export const AccountBalancesTable = observer(() => {
  const { accountBalanceStore } = useWebsocketStore();
  const balances = accountBalanceStore.balances;
  return (
    <div className={style.container}>
      <table className={style.table}>
        <thead>
          <tr>
            {fields.map((field) => (
              <th key={field.headerName}>
                <Body3 color={colors.lightGrey} fontWeight={700}>
                  {field.headerName}
                </Body3>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={style.tbody}>
          {Object.keys(balances).map((account) => {
            const row = balances[account];
            const accountType = row.account_type;
            let optionBuyingPower = null;
            let stockBuyingPower = null;
            if (accountType === 'margin') {
              if (row.margin !== undefined) {
                optionBuyingPower = row.margin.option_buying_power;
                stockBuyingPower = row.margin.stock_buying_power;
              }
            } else if (accountType === 'cash') {
              if (row.cash !== undefined && row.cash !== null) {
                optionBuyingPower = row.cash.cash_available;
                stockBuyingPower = row.cash.cash_available;
              }
            } else if (accountType === 'pdt') {
              optionBuyingPower = row.pdt.option_buying_power;
              stockBuyingPower = row.pdt.stock_buying_power;
            }
            return (
              <tr key={row.nickname}>
                <td>
                  <EditableTableField
                    backgroundColor="inherit"
                    initialValue={row.nickname}
                    color={colors.lightGrey}
                    updateValue={(value) => {
                      modifyNickname(row.account_number, value);
                    }}
                  />
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {row.account_number}
                  </Body3>
                  {row.account_number === 'BACKTEST' ? (
                    <TextButton
                      title="Reset Balance"
                      width="fit-content"
                      lineHeight="0.25rem"
                      clickHandler={resetSimAccount}
                      backgroundColor={colors.red}
                      fontSize="small"
                      color={colors.lightGrey}
                      margin="0 0 0 3px"
                    >
                      R
                    </TextButton>
                  ) : null}
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {formatBalanceValue(row.total_equity)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {formatBalanceValue(row.total_cash)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {formatBalanceValue(row.open_pl)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {formatBalanceValue(row.close_pl)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {formatBalanceValue(optionBuyingPower)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {formatBalanceValue(stockBuyingPower)}
                  </Body3>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});

const formatBalanceValue = (value) => {
  if (value === null || value === undefined) return '—';
  const rounded = ApplyRounding(value, 2);
  if (isNaN(rounded) || rounded === 0) return '—';
  return rounded;
};
